import * as React from 'react';
import styled from 'styled-components';
import { createVideoPreviewUrl } from '../../../cloudinary';
import DefaultBox from '../../../components/Box';
import camera from '../../../img/camera.svg';
import { Answer } from '../../../types/api';
import { Question } from '../types';

interface VResponseBoxProps {
    baseUrl: string;
    questions: Question[];
    onClickQuestion: (question: Question) => any;
    answers: Answer[];
    currentQuestion?: Question;
}

const Wrapper = styled.div``;

const Box = DefaultBox.extend`
    display: flex;
    justify-content: space-between;
    padding: 0;
    border: 1px solid ${p => p.theme.primary};
    overflow: hidden;
    cursor: pointer;
`;

const VideoPreview = styled.img`
    height: 4.2em;

    &[src$='.svg'] {
        height: 2.2em;
        margin: 1em;
        width: 3em;
    }
`;

const QuestionsBox: React.FC<VResponseBoxProps> = props => {
    const answerToQuestion = (question: Question): Answer | undefined => {
        return props.answers.find(answer => answer.questionId === question.id);
    };
    return (
        <Wrapper>
            {props.questions.map((question, index) => {
                const answer = answerToQuestion(question);
                const previewSrc =
                    (answer &&
                        answer.videoLink &&
                        createVideoPreviewUrl(answer.videoLink, 'c_fill,g_auto,h_100,w_140')) ||
                    camera;
                const key = question.id;
                return (
                    <Box
                        key={key}
                        onClick={() => props.onClickQuestion(question)}
                        selected={props.currentQuestion && props.currentQuestion.id === key}
                    >
                        <h3 style={{ margin: '1em' }}>Question {index + 1}</h3>
                        <VideoPreview src={previewSrc} />
                    </Box>
                );
            })}
        </Wrapper>
    );
};

export default QuestionsBox;



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/QuestionsBox.tsx